<template>
    <div>
        <page-header :title="title" :items="items" />

        <div v-if="!editMode || (editMode && hug.id)" class="row">
            <div class="col-xl-9 mb-3">
                <div class="card">
                    <div class="card-body">
                        <add-edit-form
                            v-model="hug"
                            :edit-mode="editMode"
                            :validation="$v"
                            :server-errors="serverErrors"
                        />
                    </div>
                </div>
            </div>

            <div class="col-xl-3 mb-3">
                <div class="card">
                    <div class="card-body">
                        <div :class="{ 'mb-3': editMode }">
                            <button
                                class="btn btn-success btn-static waves-effect waves-light m-1"
                                @click="submitHandler"
                            >
                                <i class="fas fa-save" />
                                Save
                            </button>
                        </div>

                        <item-information
                            :key="informationKey"
                            :edit-mode="editMode"
                            :sections="sections"
                            :item="hug"
                            @on-delete-confirm="onDeleteConfirm"
                        />
                    </div>
                </div>
            </div>
        </div>

        <skeleton-loader v-else />
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import { StatusCodes as HTTP } from 'http-status-codes';
import { required, minValue, maxValue } from 'vuelidate/lib/validators';
import AddEditForm from '@/components/hugs/AddEditForm';
import ItemInformation from '@/components/elements/ItemInformation';

export default {
    page: {
        title: 'Manage Hug'
    },

    validations: {
        hug: {
            name: {
                required
            },
            year: {
                required,
                minValue: minValue(1900),
                maxValue: maxValue(2099)
            },
            number: {
                required
            }
        }
    },

    components: {
        AddEditForm,
        ItemInformation
    },

    data() {
        const { id = null } = this.$route.params;

        return {
            title: id ? 'Edit hug' : 'Add hug',
            items: [
                {
                    text: 'Aguda',
                    to: '/'
                },
                {
                    text: 'Hugs',
                    to: '/hugs'
                },
                {
                    text: id ? 'Edit' : 'Add',
                    active: true
                }
            ],
            id,
            editMode: !!id,
            hug: {},
            informationKey: 0,
            serverErrors: []
        };
    },

    computed: {
        sections() {
            const sections = {};

            if (this.editMode) {
                sections.status = true;
            }

            return sections;
        }
    },

    async created() {
        if (this.editMode) {
            try {
                this.hug = await this.getHug(this.id);
            } catch (error) {
                console.error(error);

                this.$toasterError();
            }
        }
    },

    methods: {
        ...mapActions({
            addHug: 'hugs/store',
            deleteHug: 'hugs/destroy',
            getHug: 'hugs/show',
            updateHug: 'hugs/update'
        }),

        async submitHandler() {
            this.serverErrors = [];

            this.$v.$touch();

            if (this.$v.$invalid) {
                return;
            }

            try {
                if (!this.editMode) {
                    const added = await this.addHug(this.hug);

                    this.$router.push(`/hugs/${added.id}/edit`);
                } else {
                    const { updatedAt } = await this.updateHug({
                        id: this.id,
                        data: this.hug
                    });

                    this.hug.updatedAt = updatedAt;

                    this.$toaster('Hug updated!');
                }
            } catch (error) {
                const { response } = error;

                if (response) {
                    const { data, status } = response;

                    if (status === HTTP.BAD_REQUEST && data.errors) {
                        this.serverErrors = data.errors;

                        this.$toasterError('Recheck your form.');

                        return;
                    }
                }

                console.error(error);

                this.$toasterError();
            }
        },

        async onDeleteConfirm() {
            try {
                await this.deleteHug(this.id);

                this.$router.push('/hugs');
            } catch (error) {
                const { response } = error;

                if (response) {
                    const { data, status } = response;

                    if (status === HTTP.UNPROCESSABLE_ENTITY && data) {
                        this.$toasterError(data);

                        return;
                    }
                }

                console.error(error);

                this.$toasterError();
            }
        }
    }
};
</script>
